import CryptoJS from "crypto-js";
export class EncryptService {
    constructor() {
        this.encryptionKey = "";
    }
    setEncryptionKey(encryptionKey) {
        this.encryptionKey = encryptionKey;
    }
    payload_encode(request) {
        const payload = {
            body: request
        };
        const encryptionKey = JSON.parse(this.encryptionKey);
        const _key = CryptoJS.enc.Utf8.parse(encryptionKey);
        const _iv = CryptoJS.enc.Utf8.parse("16");
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload.body), _key, {
            keySize: 16,
            iv: _iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    }
    decryptPayload(encryptedString, key) {
        const decryptKey = JSON.parse(atob(key));
        const _key = CryptoJS.enc.Utf8.parse(JSON.parse(decryptKey));
        const _iv = CryptoJS.enc.Utf8.parse("16");
        return CryptoJS.AES.decrypt(encryptedString, _key, {
            keySize: 16,
            iv: _iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8);
    }
    decryptUsingAES256(encryptedString, key) {
        const _key = CryptoJS.enc.Utf8.parse(key);
        const _iv = CryptoJS.enc.Utf8.parse("16");
        return CryptoJS.AES.decrypt(encryptedString, _key, {
            keySize: 16,
            iv: _iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8);
    }
}
//# sourceMappingURL=EncryptService.js.map